export const SUBJECTS_FETCH_SUCCESS = "SUBJECTS_FETCH_SUCCESS";


export default function reducer(
    state = {
        data: null,
    },
    action
) {
    switch (action.type) {
        case SUBJECTS_FETCH_SUCCESS: {
            return { data: action.payload }
        }
        default:
            return state

    }
}

